import { ResponseStatus } from 'services/assist-api/entities/test-instance-response/types';

/**
 * Statuses that the response must be in in order to be marked. Draft responses cannot be marked.
 */
export const markResponseStatuses: ResponseStatus[] = [
  ResponseStatus.CLOSED,
  ResponseStatus.FINISHED
];

/**
 * Returns true if the response has a status that implies that it can be marked.
 */
export function isResponseReadyToBeMarked(status: ResponseStatus | undefined): boolean {
  return status ? markResponseStatuses.includes(status) : false;
}
